<template>
  <div>
    <GmapMap :center="center" :zoom="10" :options="options" map-type-id="roadmap" class="o-maps" @click="infoWinOpen = false">
      <GmapCluster :grid-size="30" :styles="clusterStyles" :zoom-on-click="true">
        <GmapInfoWindow :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen = false" />
        <GmapMarker
          v-for="(marker, index) in mapMarkers"
          :key="index"
          :position="marker.position"
          :clickable="true"
          :icon="marker.icon"
          @click="toggleInfoWindow(marker, index)"
        />
      </GmapCluster>
    </GmapMap>
  </div>
</template>

<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueTypes from 'vue-types'
import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues

Vue.component('GmapCluster', GmapCluster)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAPDrGTRuJY6CYfiWD--Z8SFg8_tfBwEp8',
    libraries: 'places'
  },
  installComponents: true
})

export default {
  name: 'Maps',
  components: {},
  props: {
    apiKey: VueTypes.string.def(''),
    markers: VueTypes.string.def(''),
    markerClusterImagePath: VueTypes.string.def('')
  },
  data() {
    return {
      center: {
        lat: 52.1819384,
        lng: 5.9827199
      },
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true
      },
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        maxWidth: 300,
        content: '',
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      clusterStyles: [
        {
          textColor: 'white',
          url: this.markerClusterImagePath,
          height: 30,
          width: 30,
          textSize: 13
        }
      ]
    }
  },
  computed: {
    mapMarkers() {
      return JSON.parse(this.markers)
    }
  },
  methods: {
    toggleInfoWindow: function(marker, index) {
      this.infoWindowPos = marker.position
      this.infoOptions.content = marker.infoText

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx === index) {
        this.infoWinOpen = !this.infoWinOpen
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true
        this.currentMidx = index
      }
    }
  }
}
</script>
